var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackroom = function SvgBackroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-710.000000, -546.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-HealthScreening",
    transform: "translate(690.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-Screening-List",
    transform: "translate(0.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(0.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,1 L4,1 C2.9,1 2,1.9 2,3 L2,17 L4,17 L4,3 L16,3 L16,1 Z M15,5 L21,11 L21,21 C21,22.1 20.1,23 19,23 L7.99,23 C6.89,23 6,22.1 6,21 L6.01,7 C6.01,5.9 6.9,5 8,5 L15,5 Z M14,12 L19.5,12 L14,6.5 L14,12 Z",
    id: "Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backroom.ddf7c36c.svg";
export { ForwardRef as ReactComponent };